
import { READ_ONLY_TOKEN_SESSION_STORAGE_KEY } from '@/constants/sessionStorage'
import { BASE_PATH as HISTORY_BASE_PATH, MENU_PATH as HISTORY_MENU_PATH } from '@/constants/clinicHistory'

export default {
  methods: {
    goToSection (path) {
      const needsPatientId = !this.$store.getters['session/userIsPatient'] && this.$route.query.patientId
      let route = { path: `${HISTORY_BASE_PATH}${path !== HISTORY_MENU_PATH ? `/${path}` : ''}`, query: {} }
      if (needsPatientId) route.query.patientId = this.$route.query.patientId
      if (this.$route.query.petId) route.query.petId = this.$route.query.petId
      this.$router.push(route).catch(() => {})
    }
  },
  data () {
    return {
      historyReadOnly: !!sessionStorage.getItem(READ_ONLY_TOKEN_SESSION_STORAGE_KEY)
    }
  },
  watch: {
    items (value) {
      this.$emit('anyItemSelected', value && value.length > 0);
    },
    zeroItems (value) {
      this.$emit('anyItemSelected', value);
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/clinicHistory.mixin.js